import React, { useEffect, useState } from 'react';
import './FeatureRequestStatusSelection.scss';
import { BugStore } from 'stores/private/BugStore';
import { inject, observer } from 'mobx-react';
import Select from 'react-select';
import { ProjectStore } from 'stores/private/ProjectStore';
import openIcon from 'assets/icons/np_inbox_3629724_000000.svg';
import doneIcon from 'assets/icons/np_check_1688085_000000.svg';
import testIcon from 'assets/icons/shapes.svg';
import inProgressIcon from 'assets/icons/np_loading_2550337_000000.svg';
import otherIcon from 'assets/icons/np_jewel_3913685_000000.svg';
import { ampli } from 'ampli';
import { SharedBoardStorePublic } from 'stores/public/SharedBoardStorePublic';

const defaultIcons = {
  OPEN: openIcon,
  DONE: doneIcon,
  INPROGRESS: inProgressIcon,
  TOTEST: testIcon,
};

interface FeatureRequestStatusSelectionProps {
  bugStore?: BugStore;
  sharedBoardStorePublic?: SharedBoardStorePublic;
  projectStore?: ProjectStore;
  shared?: boolean;
}

const FeatureRequestStatusSelection = ({
  bugStore,
  sharedBoardStorePublic,
  projectStore,
  shared = true,
}: FeatureRequestStatusSelectionProps) => {
  const bug = bugStore?.currentBug;
  const [data, setData] = useState('');
  const [laneKeys, setLaneKeys] = useState([] as any[]);

  const featureRequestStates = shared
    ? sharedBoardStorePublic?.getFeatureRequestStates(false)
    : projectStore?.getFeatureRequestStates(false);

  useEffect(() => {
    const laneKeysPrep: any[] = [];

    if (featureRequestStates) {
      for (let i = 0; i < featureRequestStates.length; i++) {
        const possibleLane = featureRequestStates[i];
        let icon = defaultIcons[possibleLane.key];
        if (!icon) {
          icon = otherIcon;
        }

        laneKeysPrep.push({
          title: possibleLane.title,
          value: possibleLane.key,
          icon,
        });
      }
    }

    setLaneKeys(laneKeysPrep);
  }, []);

  useEffect(() => {
    if (bug?.status && laneKeys) {
      const bugStatus = laneKeys.find((x) => x.value === bug?.status);
      setData(bugStatus);
    }
  }, [bug?.status, laneKeys]);

  if (!bug || data === '') {
    return <></>;
  }

  return (
    <>
      <Select
        className="dropdown-selection"
        classNamePrefix="dropdown-selection"
        defaultValue={data}
        value={data}
        placeholder="No status selected"
        isClearable={false}
        isSearchable={false}
        components={{
          SingleValue: (option: any) => {
            return (
              <div className="bug-prio-item">
                <img
                  src={option.data.icon}
                  alt="status"
                  className="status-icon"
                />
                <span>{option.data.title}</span>
              </div>
            );
          },
          Option: (option: any) => {
            return (
              <div
                className="option option-list-item bug-prio-item"
                onClick={() => {
                  if (option.selectOption) {
                    option.selectOption(option.data);
                  }
                }}
              >
                <img
                  src={option.data.icon}
                  alt="status"
                  className="status-icon"
                />
                <span>{option.data.title}</span>
              </div>
            );
          },
        }}
        onChange={(selected: any) => {
          if (selected) {
            bugStore!.updateBug(bug.id, {
              status: selected.value,
            });
            setData(selected);

            ampli.ticketStatusChanged({
              bugId: bug.id,
              name: selected.value,
            });
          }
        }}
        options={laneKeys}
      />
    </>
  );
};

export default inject(
  'bugStore',
  'sharedBoardStorePublic',
  'projectStore',
)(observer(FeatureRequestStatusSelection));
